import { m } from '@aimfora/i18n'
import { createFileRoute } from '@tanstack/react-router'
import { AiPage } from '~/components/admin/ai-page'
import { PageHeader } from '~/components/app-shell'

export const Route = createFileRoute('/_authed/_admin/admin/ai')({
  head: () => ({ meta: [{ title: `${m.admin_nav_ai()} – ${m.app_name()}` }] }),
  component: AiRoute,
})

function AiRoute() {
  return (
    <>
      <PageHeader title={m.admin_nav_ai()} />
      <AiPage />
    </>
  )
}
